import {FETCH_SHOPPINGCART_ITEMS, ADD_SHOPPINGCART_ITEM, UPDATE_SHOPPINGCART_ITEM, DELETE_SHOPPINGCART_ITEM, DELETE_SHOPPING_CART} from '../actions';

export default function (state={}, action){
  switch(action.type){
    case FETCH_SHOPPINGCART_ITEMS:
      return action.payload.data;
    case ADD_SHOPPINGCART_ITEM:
      return state;
    case UPDATE_SHOPPINGCART_ITEM:
      return state;
    case DELETE_SHOPPINGCART_ITEM:
      return state;
    case DELETE_SHOPPING_CART:
      return "empty";
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_shoppingCartItems.js